var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00013 0C6.66013 0 7.20013 0.54 7.20013 1.2V10.8C7.20013 11.46 6.66013 12 6.00013 12C5.34013 12 4.80013 11.46 4.80013 10.8V1.2C4.80013 0.54 5.34013 0 6.00013 0ZM1.2 3.6H1.37143C2.03143 3.6 2.57143 4.14 2.57143 4.8V10.8C2.57143 11.46 2.03143 12 1.37143 12H1.2C0.54 12 0 11.46 0 10.8L0 4.8C0 4.14 0.54 3.6 1.2 3.6ZM11.9999 8.05714C11.9999 7.39714 11.4599 6.85714 10.7999 6.85714C10.1399 6.85714 9.59994 7.39714 9.59994 8.05714V10.8C9.59994 11.46 10.1399 12 10.7999 12C11.4599 12 11.9999 11.46 11.9999 10.8V8.05714Z",
    fill: "#2D87F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/BarChart.705c314d397c4ee53440812022abe1ab.svg";
export { ForwardRef as ReactComponent };